export const SEARCH_THROTTLE_MILISECONDS = 1000;
export const PAGINATION_PAGE_SIZE = 100;
export const BREAKPOINTS = { mobile: 0, tablet: 768, desktop: 1280 };
